export default __webpack_public_path__ + "static/weather-balloon-a0e4fa4d318ea099884f2a4960e4780c.mp4";